export default "__VITE_ASSET__BxSJwluJ__"